import Head from 'next/head';
import React from 'react';
import Features from '../components/Business/B2Bstack/Features/Features';
import Heading from '../components/Business/B2Bstack/Heading/Heading';
import Navbar from '../components/Common/Navbar/Navbar';
import Industries from '../components/Business/B2Bstack/indutries/Industries';
import StickyLayout from '../components/Business/B2Bstack/stickyLayout/StickyLayout';
import Contract from '../components/Business/B2Bstack/contract/Contract';
import WeDeliver from '../components/Business/B2Bstack/we-deliver/We-deliver';
import Hero from '../components/B2B/Hero/Hero';
import Comparision from '../components/B2B/Comparision/Comparision';
import WhyUs from '../components/B2B/WhyUs/WhyUs';
import UseCases from '../components/B2B/UseCases/UseCases';

const business = () => {
  return (
    <>
      <Head>
        <title>All-in-One B2B eCommerce Platform | Socommerz - Streamlined Buying & Vendor Collaboration</title>
        <meta name="title" content="All-in-One B2B eCommerce Platform | Socommerz - Streamlined Buying & Vendor Collaboration" />
        <meta name="description" content="Transform your B2B eCommerce with Socommerz's no-code platform. Design, launch, and optimize your platform to enhance conversions, revenue, and customer loyalty. Our services include cataloging, inventory management, bulk orders, purchase functionalities, and seamless integrations for effective vendor collaboration." />
        <meta name="keywords"
          content="B2B eCommerce platform, no-code B2B stack, Socommerz, business stack, bulk order functionality, vendor collaboration, inventory management, cataloging services, B2B integrations, AI-powered operations, B2B buying platform, optimize eCommerce, B2B solutions, eCommerce platform for startups" />
        <meta name="robots" content="index,follow" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.socommerz.com/b2b-stack/" />
        <meta property="og:title" content="All-in-One B2B eCommerce Platform | Socommerz - Streamlined Buying & Vendor Collaboration" />
        <meta property="og:description" content="Transform your B2B eCommerce with Socommerz's no-code platform. Design, launch, and optimize your platform to enhance conversions, revenue, and customer loyalty. Our services include cataloging, inventory management, bulk orders, purchase functionalities, and seamless integrations for effective vendor collaboration." />
        <link rel="canonical" href="https://www.socommerz.com/b2b-stack/" />
        <link rel="alternate" href="https://www.socommerz.com/b2b-stack/" hrefLang="en-in" />
        <meta property="twitter:url" content="https://www.socommerz.com/b2b-stack/" />
        <meta property="twitter:title" content="All-in-One B2B eCommerce Platform | Socommerz - Streamlined Buying & Vendor Collaboration" />
        <meta property="twitter:description" content="Transform your B2B eCommerce with Socommerz's no-code platform. Design, launch, and optimize your platform to enhance conversions, revenue, and customer loyalty. Our services include cataloging, inventory management, bulk orders, purchase functionalities, and seamless integrations for effective vendor collaboration." />
      </Head>
      <main>
        <Hero/>
        <WeDeliver />
        <WhyUs/>
        <UseCases/>
        <Comparision/>
        <Heading />
        <Navbar />
        <StickyLayout />
        {/* <Industries /> */}
      </main>
    </>
  );
};

export default business;
